export const FEEDBACK_TEXT = {
	helpTitle: 'Help us make it better!',
	suggestion:
		'Got a suggestion or an idea? Share your thoughts to help us improve your experience.',
	leaveFeedback: 'Leave feedback',
};
